<template>
  <label class="checkbox">
    <div class="checkbox__field">
      <div class="checkbox__icon-wrapper">
        <icon
          class="checkbox__icon"
          :key="state"
          :name="state ? 'square-check' : 'square'"
          :art="state ? 'solid' : 'light'"
        />
      </div>
      <input
        v-model="state"
        :name="name"
        :value="value"
        :disabled="disabled"
        type="checkbox"
        class="checkbox__input"
        @change="$emit('input', state)"
      />
      <span v-if="text" class="checkbox__label" v-html="text" />
    </div>
  </label>
</template>

<script>
import Icon from './Icon'

export default {
  name: 'Checkbox',

  components: { Icon },

  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Object, Number, Boolean],
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },

  data() {
    return { state: this.value }
  },

  computed: {
    /**
     * returns the color of the checkbox:
     *   → if checked, always original-green
     *   → if un-checked, depending on the theme: black for black and white for white ;-)
     *
     * @return {String}
     */
    checkboxColor() {
      return this.state ? 'original-green' : this.theme
    },
  },

  watch: {
    value(value) {
      this.state = value
    },
  },
}
</script>

<style scoped lang="postcss">
.checkbox {
  display: inline-flex;
  flex-direction: row;
  cursor: pointer;
  position: relative;
  vertical-align: middle;
  height: auto;
  flex-wrap: wrap;

  & > *,
  & >>> * {
    pointer-events: none;
  }

  &__field {
    display: flex;
  }

  .checkbox__icon-wrapper {
    height: 100%;
    color: #5bac26;
  }

  .checkbox__icon {
    font-size: 22px;
  }

  &__input {
    cursor: pointer;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;

    &:hover {
      &:after {
        opacity: 0.3;
      }
    }

    &:checked {
      &:after {
        opacity: 1;
      }
    }
  }

  &__label {
    padding-left: 10px;
  }

  &__errors {
    width: 100%;
    padding-left: 27px;
    margin-top: 5px;
  }
}
</style>
